import { connect, ConnectedProps } from 'react-redux'
import SellStepHeaderAccounts from '../../../../../headers/SellStepHeaderAccounts'
import SellStepHeaderCosts from '../../../../../headers/SellStepHeaderCosts'
import SellStepHeaderFinancialRows from '../../../../../headers/SellStepHeaderFinancialRows'
import SellStepHeaderMain, { useSellStepHeaderMainLogic } from '../../../../../headers/SellStepHeaderMain'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import withLoading from '../../../../../../../../../../../utils/hoc/withLoading'
import useSellDeliveryNoteHeaderUrls from '../../../../../../../../../../../utils/hooks/sells/orders/useSellDeliveryNoteHeaderUrls'
import { ComponentTabObject } from '../../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../../utils/reducers'
import { CostSellPayload } from '../../../../../../../../../../../utils/reducers/company/costsSell'
import { WorkingCenterPayload } from '../../../../../../../../../../../utils/reducers/company/workingCenters'
import { SellTagsPayload } from '../../../../../../../../../../../utils/reducers/sells/sellTags'
import { EmployeesPayload } from '../../../../../../../../../../../utils/reducers/company/employees'
import { SellVariablePayload } from '../../../../../../../../../../../utils/reducers/company/sellVariable'
import SellStepHeaderVariables from '../../../../../headers/SellStepHeaderVariables'
import SellStepHeaderShipping from '../../../../../headers/SellStepHeaderShipping'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import useSellOrderHeaderUrls from '../../../../../../../../../../../utils/hooks/sells/orders/useSellOrderHeaderUrls'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'
import { FormElement, FormRender } from '../../../../../../../../../../../forms/FormRenderer/types'
import { SellModelType } from '../../../../../headers/types'
import ITHeaderText from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { CustomSelectBlockedItemsSearchbar } from '../../../../../../../../../../../forms/CustomSelect/CustomSelectBlockedItems'
import { notHaveCountersWorkingCenter } from '../../../../../../../../../../../utils/globals/order/order'
import { sortEmployeesByUser } from '../../../../../../../../../../../utils/globals/employees'
import { InputWithLabelMargin } from '../../../../../../../../../../../forms/Input'
import { CustomSellSelectCampaign, CustomSellSelectProject } from '../../../../../../../../../../../specificComponents/sells/components'
import { ITHeaderOrderTagsNew } from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components'
import { returnClassOfSpanTemplate } from '../../../../../../../../../../../utils/globals/tailwind'
import { CustomSelectWithSearchBar } from '../../../../../../../../../../../forms/CustomSelect'
import { Fragment } from 'react'
import InputTableTopHeader from '../../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import ModalEditOrderCurrency from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditOrderCurrency'
import ModalEditOrderWorkingCenter from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditOrderWorkingCenter'
import { ProductTypesPayload } from '../../../../../../../../../../../utils/reducers/products/productTypes'

type SellDeliveryNoteCreateStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & ReduxSellDeliveryNoteCreateStepITHeader & {}

const SellDeliveryNoteCreateStepITHeader: React.FC<SellDeliveryNoteCreateStepITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={SellDeliveryNoteCreateStepITHeaderDefault} NewComponent={SellDeliveryNoteCreateStepITHeaderNew} {...rest} />
}

const SellDeliveryNoteCreateStepITHeaderDefault: React.FC<SellDeliveryNoteCreateStepITHeaderProps> = ({ workingCenters, employees, sellTags, ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useSellDeliveryNoteHeaderUrls()
    const tabs: ComponentTabObject = {
        'main': {
            component: SellStepHeaderMain,
            text: t('dataDeliveryNote', 'Datos del albarán'),
            extraProps: { workingCenters, employees, sellTags: sellTags?.sell, orderHeaderURLs, updateCurrencyURL: '/api/app/order/sell/sellDeliveryNote/updateSellDeliveryNoteCurrency'}
        },
        'discounts': {
            component: SellStepHeaderFinancialRows,
            text: t('discountsAndRecharges', 'Descuentos y recargos'),
            permission: 'sell.deliveryNote',
            extraProps: { orderHeaderURLs }
        },
        'costs': {
            component: SellStepHeaderCosts,
            text: t('costsDeliveryNote', 'Gastos del albarán'),
            permission: 'sell.deliveryNote',
            extraProps: { orderHeaderURLs }
        },
        'shipping': {
            component: SellStepHeaderShipping,
            text: t('shipping', 'Transporte'),
            permission: 'sell.deliveryNote',
            extraProps: { orderHeaderURLs, modelId: 'SellDeliveryNoteId' }
        },
        'accounts': {
            component: SellStepHeaderAccounts,
            text: t('divideIntoChapters', 'Dividir en capítulos'),
            permission: 'sell.deliveryNote',
            extraProps: { orderHeaderURLs }
        },
        'variables': {
            component: SellStepHeaderVariables,
            text: t('sellVariables', 'Variables de venta'),
            permission: 'sell.deliveryNote',
            extraProps: { orderHeaderURLs }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const SellDeliveryNoteCreateStepITHeaderNew: React.FC<SellDeliveryNoteCreateStepITHeaderProps> = ({ workingCenters, employees, sellTags, headerData, getCompleteData, ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useSellOrderHeaderUrls()
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData: rest?.setCompleteData, updateDataURL: rest?.updateDataURL })
    const { dictSellStepHeaderExtraData, activeCurrencies, openModal, setOpenModal, changeCurrencyId, dictWarehouses, workingCenterAddress, memorizedWorkingCenters, changeWorkingCenterId, getCustomerProjects, customerProjects, getCustomerCampaigns, customerCampaigns } = useSellStepHeaderMainLogic({ headerData: headerData || {}, workingCenters, handleChange, ...rest })
    const workingCenterSection: FormElement<keyof SellModelType>[] = []

    if (headerData?.QuoteOrderId || headerData?.SellOrderId || headerData?.SellDeliveryNoteOrderId) {
        workingCenterSection.push({
            name: 'WorkingCenterId',
            component: 'Custom',
            render: ({ value }) => <ITHeaderText label={t('soldBy', 'Vendido por')} value={headerData?.WorkingCenter?.name || ''} />,
            hideSectionByDefault: true
        })
    } else {
        workingCenterSection.push({
            name: 'WorkingCenterId',
            component: 'Custom',
            render: ({ extraProps }) => {
                return <CustomSelectBlockedItemsSearchbar label={t('soldBy', 'Vendido por')} items={extraProps.memorizedWorkingCenters} value={extraProps.WorkingCenterId} onChange={extraProps.changeWorkingCenterId} isStateLess={true} blockItemsFnc={extraProps.notHaveCountersWorkingCenter} sortItems={true} />
            },
            hideSectionByDefault: true,
            extraProps: {
                memorizedWorkingCenters,
                WorkingCenterId: headerData?.WorkingCenterId,
                changeWorkingCenterId,
                notHaveCountersWorkingCenter
            }
        })
    }
    const sections: FormRender<SellModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('draftN', 'Nº de borrador')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'processed_date',
                    component: 'InputCalendarStateFull',
                    label: t('date', 'Fecha'),
                    onlyValids: true,
                    required: true
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('representative', 'Representante'),
                    items: employees || {},
                    sortItems: true,
                    fieldName: 'fullname_short',
                    sortFunction: (emp) => sortEmployeesByUser(emp, false)
                },
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => {
                        return <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={props.onChange} defaultValue={headerData?.custom_name || ''} className='custom_name_input_field' />
                    }
                },
                {
                    name: 'CustomerProjectId',
                    component: 'Custom',
                    render: ({ extraProps, setLockOnClickOut }) => <CustomSellSelectProject getCompleteData={getCustomerProjects} handleChange={handleChange} headerData={headerData || {}} items={extraProps.customerProjects} setLockOnClickOut={setLockOnClickOut} />,
                    extraProps: {
                        customerProjects: customerProjects || {}
                    }
                },
                {
                    name: 'CampaignCustomerId',
                    component: 'Custom',
                    render: ({ extraProps, setLockOnClickOut }) => <CustomSellSelectCampaign getCompleteData={getCustomerCampaigns} handleChange={handleChange} headerData={headerData || {}} items={extraProps.customerCampaigns} label={t('campaign', 'Campaña')} setLockOnClickOut={setLockOnClickOut} />,
                    extraProps: {
                        customerCampaigns: customerCampaigns || {}
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'OrderTags',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return (
                            <ITHeaderOrderTagsNew tagType={1} getCompleteData={getCompleteData} dictTags={extraProps?.dictTags || []} className={returnClassOfSpanTemplate(3) + ' order_top_header_custom_select_tags'} selectedTags={headerData?.tags || []} onChange={handleChange} headerData={headerData || {}} />)
                    },
                    extraProps: {
                        dictTags: sellTags?.sell
                    }
                },
                ...workingCenterSection,
                {
                    name: 'WorkingCenterAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterFiscalAddress', 'Dirección Fiscal centro de trabajo')} value={workingCenterAddress || ''} />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'CustomerAddress',
                    component: 'Custom',
                    render: ({ value }) => {
                        return <ITHeaderText label={t('fiscalAddressCustomer', 'Dirección Fiscal cliente')} value={dictSellStepHeaderExtraData?.CustomerAddress || ''} />
                    },
                    extraProps: {
                        dictSellStepHeaderExtraData
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'CustomSelectBlockedItemsSearchbar',
                    label: t('workingCenter', 'Centro de trabajo'),
                    items: memorizedWorkingCenters || {},
                    blockItemsFnc: notHaveCountersWorkingCenter,
                    onChange: getCompleteData,
                    sortItems: true,
                    hideSectionByDefault: true
                },
                {
                    name: 'WarehouseId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('warehouse', 'Almacén'),
                    items: dictWarehouses || {},
                    className: returnClassOfSpanTemplate(5),
                    value: headerData?.WarehouseId || 0,
                    hideSectionByDefault: true
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectWithSearchBar label={t('currency', 'Moneda')} items={extraProps.activeCurrencies} value={extraProps.CurrencyId} onChange={extraProps.changeCurrencyId} className={returnClassOfSpanTemplate(2)} isStateLess={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        activeCurrencies,
                        CurrencyId: headerData?.CurrencyId,
                        changeCurrencyId
                    }
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />
                    },
                    hideSectionByDefault: true
                }
            ]
        }
    ]

    return (
        <Fragment>
            <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
            {openModal?.type === 'edit' && openModal?.allRowData?.CurrencyId ?
                <ModalEditOrderCurrency Currency={activeCurrencies?.[openModal?.allRowData?.CurrencyId]?.name} id={headerData?.id} {...{ updateCurrencyURL: '/api/app/order/sell/sellOrder/updateSellOrderCurrency', onSubmit: getCompleteData, setOpened: () => setOpenModal(null), allRowData: openModal?.allRowData }} />
                : null
            }
            {openModal?.type === 'edit' && openModal?.allRowData?.WorkingCenterId ?
                <ModalEditOrderWorkingCenter id={headerData?.id} {...{ updateWorkingCenterURL: orderHeaderURLs.updateWorkingCenter, onSubmit: getCompleteData, setOpened: () => setOpenModal(null), allRowData: openModal?.allRowData }} />
                : null
            }
        </Fragment>
    )
}

const sellDeliveryNoteCreateStepITHeaderDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCostsSell: (payload: CostSellPayload) => ({ type: 'CHANGE_COSTSELL', payload }),
    setSellTags: (payload: SellTagsPayload) => ({ type: 'CHANGE_SELL_TAGS', payload }),
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setSellVariables: (payload: SellVariablePayload) => ({ type: 'CHANGE_SELLVARIABLE', payload }),
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxSellDeliveryNoteCreateStepITHeader = ConnectedProps<typeof sellDeliveryNoteCreateStepITHeaderConnect>
const mapSellDeliveryNoteCreateStepITHeaderConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, costsSell: state.costsSell, sellTags: state.sellTags, employees: state.employees, sellVariables: state.sellVariables, productTypes: state.productTypes })
const sellDeliveryNoteCreateStepITHeaderConnect = connect(mapSellDeliveryNoteCreateStepITHeaderConnector, sellDeliveryNoteCreateStepITHeaderDispatch)
const sellDeliveryNoteCreateStepITHeaderConnectLoading = withLoading(SellDeliveryNoteCreateStepITHeader, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/cost/costSell/getAllCostSells', propName: 'costsSell', setFunctionName: 'setCostsSell' }, { fetchUrl: '/api/app/order/sell/sellTag/getAllSellTags', propName: 'sellTags', setFunctionName: 'setSellTags' }, { fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/config/sell/sellVariable/getAllSellVariables', propName: 'sellVariables', setFunctionName: 'setSellVariables' }, { fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const SellDeliveryNoteCreateStepITHeaderConnect = sellDeliveryNoteCreateStepITHeaderConnect(sellDeliveryNoteCreateStepITHeaderConnectLoading)

export default SellDeliveryNoteCreateStepITHeaderConnect